/**
 * Company: SPHMedia
 * Description: [Section headings component for the homepage]
 */

import ChevronImage from "@assets/video_widget/Chevron.webp";
import Heading from "@elements/Typography/Heading";
import { ReactElement } from "react";
import { Link } from "react-router";

type SectionHeadingsProps = {
  headingText: string;
  headingLink: string;
};

/**
 * SectionHeadings
 * Description: [Renders section headings for the homepage, including a link to the videos page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function SectionHeadings({
  headingText,
  headingLink,
}: SectionHeadingsProps): ReactElement {
  // Add component logic and state here

  return (
    <>
      <Heading
        Element="h2"
        className="text-red-100 text-2.5md font-bold mt-5 mb-5 hover:underline hover:cursor-pointer hover:text-red-200"
      >
        <Link
          reloadDocument
          to={headingLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {headingText}
          <img
            alt="toggle-button-chevie"
            height={24}
            width={24}
            className="pl-100 inline"
            src={ChevronImage}
          />
        </Link>
      </Heading>
    </>
  );
}
